import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
// eslint-disable-next-line no-unused-vars
import { collection, query, where, getDocs, addDoc, updateDoc, doc, serverTimestamp, writeBatch } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useAuth } from '../context/AuthContext';
// eslint-disable-next-line no-unused-vars
import { IoArrowBack, IoCubeOutline, IoCheckmarkCircleOutline, IoAddCircleOutline, IoSearchOutline, IoScanOutline, IoStorefrontOutline, IoCameraOutline, IoCloseCircleOutline, IoTrashOutline } from 'react-icons/io5';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './PaqueteriaScreen.css';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import './PaqueteriaScreen.css';

function PaqueteriaScreen() {
    const { userData, currentUser } = useAuth();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode');

    const [paquetes, setPaquetes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filtroEstado, setFiltroEstado] = useState('en_caseta'); // 'en_caseta' o 'entregado'
    const [busqueda, setBusqueda] = useState('');

    // Modal state para confirmación de entrega premium
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [paqueteAEntregar, setPaqueteAEntregar] = useState(null); // { id, casillaLocker }

    // Modal state para recibir paquete
    const [showRecibirModal, setShowRecibirModal] = useState(false);
    const [nuevoPaquete, setNuevoPaquete] = useState({
        repartidor: '',
        casillaLocker: '',
        detallesCasa: '',
        residenteId: '' // Opcional por ahora si solo se anota la casa
    });
    const [fotoEvidencia, setFotoEvidencia] = useState(null);
    const [uploadingFoto, setUploadingFoto] = useState(false);

    // Modal state para Gestionar Lockers (Admin/Comite)
    const [showAdminLockersModal, setShowAdminLockersModal] = useState(false);
    const [nuevoLockerId, setNuevoLockerId] = useState('');

    // Lista de casas y lockers
    const [casasDisponibles, setCasasDisponibles] = useState([]);
    const [lockersDisponibles, setLockersDisponibles] = useState([]);
    const [todosLockers, setTodosLockers] = useState([]);

    const showAdminControls = userData?.rol === 'vigilante' || userData?.rol === 'admin' || (userData?.rol === 'comite' && mode === 'admin');
    const isManager = userData?.rol === 'admin' || (userData?.rol === 'comite' && mode === 'admin');

    useEffect(() => {
        if (!userData?.condominioId) return;
        fetchPaquetes();
        fetchCasas();
        fetchLockers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userData, filtroEstado, mode]);

    const fetchPaquetes = async () => {
        setLoading(true);
        try {
            let q;
            const isResidentView = userData?.rol === 'residente' || (userData?.rol === 'comite' && mode !== 'admin');
            if (isResidentView) {
                q = query(
                    collection(db, 'paquetes'),
                    where('condominioId', '==', userData.condominioId),
                    where('detallesCasa', '==', userData.numeroCasa || ''),
                    where('estado', '==', filtroEstado)
                );
            } else {
                q = query(
                    collection(db, 'paquetes'),
                    where('condominioId', '==', userData.condominioId),
                    where('estado', '==', filtroEstado)
                );
            }
            const snapshot = await getDocs(q);
            const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            // Ordenamos localmente por fecha (los más recientes primero)
            list.sort((a, b) => {
                const dateA = a.fechaRecepcion?.toMillis() || 0;
                const dateB = b.fechaRecepcion?.toMillis() || 0;
                return dateB - dateA; // Descendente
            });

            setPaquetes(list);
        } catch (error) {
            console.error("Error cargando paquetes:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchCasas = async () => {
        try {
            const q = query(collection(db, 'usuarios'), where('condominioId', '==', userData.condominioId));
            const snap = await getDocs(q);
            const casasSet = new Set();
            snap.docs.forEach(doc => {
                const data = doc.data();
                if (data.numeroCasa) casasSet.add(data.numeroCasa);
                if (data.residencia) casasSet.add(data.residencia);
            });
            setCasasDisponibles(Array.from(casasSet).sort());
        } catch (e) {
            console.error("Error fetching casas", e);
        }
    };

    const fetchLockers = async () => {
        try {
            const q = query(collection(db, 'lockers'), where('condominioId', '==', userData.condominioId));
            const snap = await getDocs(q);
            const list = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            list.sort((a, b) => {
                const numA = parseInt(a.identificador.replace(/\D/g, '')) || 0;
                const numB = parseInt(b.identificador.replace(/\D/g, '')) || 0;
                if (numA === numB) return a.identificador.localeCompare(b.identificador);
                return numA - numB;
            });

            setTodosLockers(list);
            setLockersDisponibles(list.filter(l => l.estado === 'libre'));
        } catch (e) {
            console.error("Error fetching lockers", e);
        }
    };

    const handleSearchChange = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    const handleOpenRecibir = () => {
        setNuevoPaquete({ repartidor: '', casillaLocker: '', detallesCasa: '', residenteId: '' });
        setFotoEvidencia(null);
        setShowRecibirModal(true);
    };

    const handleFotoChange = (e) => {
        if (e.target.files[0]) {
            setFotoEvidencia(e.target.files[0]);
        }
    };

    const handleRegistrarPaquete = async (e) => {
        e.preventDefault();
        if (!nuevoPaquete.repartidor || !nuevoPaquete.detallesCasa) {
            alert("El repartidor y la casa destino son obligatorios.");
            return;
        }

        setUploadingFoto(true);

        try {
            let fotoUrl = null;

            if (fotoEvidencia) {
                const storage = getStorage();
                const fileRef = ref(storage, `paquetes/${userData.condominioId}/${Date.now()}_${fotoEvidencia.name}`);
                await uploadBytes(fileRef, fotoEvidencia);
                fotoUrl = await getDownloadURL(fileRef);
            }

            const paqueteData = {
                condominioId: userData.condominioId,
                repartidor: nuevoPaquete.repartidor,
                casillaLocker: nuevoPaquete.casillaLocker || 'N/A',
                detallesCasa: nuevoPaquete.detallesCasa,
                estado: 'en_caseta',
                recibidoPorVigilanteId: currentUser.uid,
                fechaRecepcion: serverTimestamp(),
                fotoEvidencia: fotoUrl
            };

            const paqueteRef = await addDoc(collection(db, 'paquetes'), paqueteData);

            // Ocupar locker si se seleccionó uno
            if (nuevoPaquete.casillaLocker && nuevoPaquete.casillaLocker !== 'N/A') {
                const lockerId = todosLockers.find(l => l.identificador === nuevoPaquete.casillaLocker)?.id;
                if (lockerId) {
                    await updateDoc(doc(db, 'lockers', lockerId), {
                        estado: 'ocupado',
                        paqueteId: paqueteRef.id
                    });
                }
            }

            setShowRecibirModal(false);
            setFotoEvidencia(null);
            fetchPaquetes();
            fetchLockers();
            alert("Paquete registrado exitosamente en caseta.");

        } catch (error) {
            console.error("Error registrando paquete:", error);
            alert("Hubo un error al registrar el paquete.");
        } finally {
            setUploadingFoto(false);
        }
    };

    const handlePedirConfirmacionEntrega = (paqueteId, casillaLocker) => {
        setPaqueteAEntregar({ id: paqueteId, casillaLocker });
        setShowConfirmModal(true);
    };

    const ejecutarEntregaPaquete = async () => {
        if (!paqueteAEntregar) return;
        const { id, casillaLocker } = paqueteAEntregar;

        try {
            const paqueteRef = doc(db, 'paquetes', id);
            await updateDoc(paqueteRef, {
                estado: 'entregado',
                entregadoPorVigilanteId: currentUser.uid,
                fechaEntrega: serverTimestamp()
            });

            // Liberar locker si estaba asignado
            if (casillaLocker && casillaLocker !== 'N/A') {
                const lockerId = todosLockers.find(l => l.identificador === casillaLocker)?.id;
                if (lockerId) {
                    await updateDoc(doc(db, 'lockers', lockerId), {
                        estado: 'libre',
                        paqueteId: null
                    });
                }
            }

            setShowConfirmModal(false);
            setPaqueteAEntregar(null);
            fetchPaquetes();
            fetchLockers();
        } catch (error) {
            console.error("Error al marcar como entregado:", error);
            alert("Hubo un error al actualizar el paquete.");
        }
    };

    const handleCrearLocker = async (e) => {
        e.preventDefault();
        if (!nuevoLockerId.trim()) return;

        try {
            await addDoc(collection(db, 'lockers'), {
                condominioId: userData.condominioId,
                identificador: nuevoLockerId.toUpperCase().trim(),
                estado: 'libre',
                paqueteId: null
            });
            setNuevoLockerId('');
            fetchLockers();
        } catch (e) {
            console.error(e);
        }
    };

    const handleEliminarLocker = async (id) => {
        if (!window.confirm("¿Seguro que deseas eliminar este locker?")) return;
        try {
            await updateDoc(doc(db, 'lockers', id), { estado: 'eliminado' }); // o deleteDoc
            fetchLockers();
        } catch (e) {
            console.error(e);
        }
    };

    const paquetesFiltrados = paquetes.filter(p =>
        (p.detallesCasa || '').toLowerCase().includes(busqueda) ||
        (p.repartidor || '').toLowerCase().includes(busqueda) ||
        (p.casillaLocker || '').toLowerCase().includes(busqueda)
    );

    return (
        <div className="ks-page">
            <KondoSidebar activeRoute="/paqueteria" />

            <main className="ks-main">
                <KondoBrandHeader title={showAdminControls ? "Administración" : undefined} showBackButton={false} />

                <div className="ks-scroll-area">
                    <div className="paqueteria-container">
                        {/* --- Premium Banner --- */}
                        <div className="muro-header-stitch">
                        <div className="muro-hero-card">
                            <button type="button" onClick={() => navigate('/accesos')} className="back-btn-lockers glass" aria-label="Volver">
                                <IoArrowBack size={24} />
                            </button>
                            <div className="muro-hero-content">
                                <h1>Lockers</h1>
                                <p>Paquetes recibidos</p>
                            </div>

                            <IoCubeOutline className="muro-hero-icon" />
                        </div>
                    </div>

                <div className="paqueteria-controls" style={{ marginTop: '15px' }}>
                    <div className="paqueteria-search-bar" style={{ marginBottom: '12px' }}>
                        <IoSearchOutline className="paqueteria-search-icon" />
                        <input
                            type="text"
                            placeholder="Buscar casa, locker..."
                            value={busqueda}
                            onChange={handleSearchChange}
                        />
                    </div>
                    {showAdminControls && (
                        <div style={{ display: 'flex', gap: '8px' }}>
                            {isManager && (
                                <button className="btn-secondary" onClick={() => setShowAdminLockersModal(true)} style={{ flex: 1, padding: '10px', borderRadius: '12px', border: '1px solid #e2e8f0', background: 'white', color: '#64748b', fontWeight: 600, fontSize: '0.85rem' }}>
                                    Gestionar
                                </button>
                            )}
                            <button className="btn-recibir-paquete" onClick={handleOpenRecibir} style={{ flex: 2, padding: '10px', borderRadius: '12px', background: '#4c1d95', color: 'white', border: 'none', fontWeight: 600, fontSize: '0.85rem', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                <IoAddCircleOutline size={18} /> Registrar
                            </button>
                        </div>
                    )}
                </div>

                <div className="tabs-container" style={{ marginBottom: '20px' }}>
                    <button
                        className={`tab-btn ${filtroEstado === 'en_caseta' ? 'active' : ''}`}
                        onClick={() => setFiltroEstado('en_caseta')}
                    >
                        Pendientes
                    </button>
                    <button
                        className={`tab-btn ${filtroEstado === 'entregado' ? 'active' : ''}`}
                        onClick={() => setFiltroEstado('entregado')}
                    >
                        Historial
                    </button>
                </div>

                <div className="paqueteria-content">
                    {loading ? (
                        <div className="loading-state">
                            <div className="spinner"></div>
                            <p>Cargando paquetes...</p>
                        </div>
                    ) : paquetesFiltrados.length === 0 ? (
                        <div className="empty-state">
                            <div className="empty-icon">
                                <IoCubeOutline size={48} />
                            </div>
                            <h3>No hay paquetes {filtroEstado === 'en_caseta' ? 'pendientes' : 'entregados'}</h3>
                            <p>{busqueda ? 'No coincide ningún paquete con tu búsqueda.' : 'Los paquetes registrados aparecerán aquí.'}</p>
                        </div>
                    ) : (
                        <div className="paquetes-grid">
                            {paquetesFiltrados.map(paquete => (
                                <div key={paquete.id} className={`paquete-card ${paquete.estado}`}>
                                    <div className="paquete-header">
                                        <div className="paquete-casa">
                                            <span className="label">Destino</span>
                                            <span className="value">Casa {paquete.detallesCasa}</span>
                                        </div>
                                        <div className={`paquete-status-badge ${paquete.estado}`}>
                                            {paquete.estado === 'en_caseta' ? 'En Caseta' : 'Entregado'}
                                        </div>
                                    </div>
                                    <div className="paquete-body">
                                        <div className="info-row">
                                            <span className="label">Servicio/Repartidor:</span>
                                            <span className="value">{paquete.repartidor}</span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">Locker/Ubicación:</span>
                                            <span className="value highlighted">{paquete.casillaLocker || 'No asignado'}</span>
                                        </div>
                                        <div className="info-row">
                                            <span className="label">Recibido en caseta:</span>
                                            <span className="value date">{paquete.fechaRecepcion?.toDate().toLocaleString() || 'Desconocido'}</span>
                                        </div>
                                        {paquete.fotoEvidencia && (
                                            <div className="info-row" style={{ marginTop: '10px' }}>
                                                <a href={paquete.fotoEvidencia} target="_blank" rel="noreferrer" style={{ fontSize: '0.85rem', color: '#3b82f6', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <IoCameraOutline size={16} /> Ver Evidencia
                                                </a>
                                            </div>
                                        )}
                                    </div>

                                    {paquete.estado === 'en_caseta' && showAdminControls && (
                                        <div className="paquete-actions">
                                            <button
                                                className="btn-entregar"
                                                onClick={() => handlePedirConfirmacionEntrega(paquete.id, paquete.casillaLocker)}
                                            >
                                                <IoCheckmarkCircleOutline size={20} /> Marcar como Entregado
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Modal para Registrar Paquete */}
                {showRecibirModal && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <h3>Registrar Nuevo Paquete</h3>
                            <form onSubmit={handleRegistrarPaquete}>
                                <div className="form-group">
                                    <label>Destino (Número de Casa) *</label>
                                    <input
                                        type="text"
                                        value={nuevoPaquete.detallesCasa}
                                        onChange={e => setNuevoPaquete({ ...nuevoPaquete, detallesCasa: e.target.value })}
                                        list="casas-list"
                                        placeholder="Ej: Lote 15 Mz 2"
                                        required
                                    />
                                    <datalist id="casas-list">
                                        {casasDisponibles.map(casa => <option key={casa} value={casa} />)}
                                    </datalist>
                                    <small>Escribe o selecciona la casa de la lista.</small>
                                </div>

                                <div className="form-group">
                                    <label>Servicio de Reparto *</label>
                                    <input
                                        type="text"
                                        value={nuevoPaquete.repartidor}
                                        onChange={e => setNuevoPaquete({ ...nuevoPaquete, repartidor: e.target.value })}
                                        placeholder="Amazon, MercadoLibre, DHL, Estafeta..."
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Locker o Ubicación Asignada (Opcional)</label>
                                    <select
                                        value={nuevoPaquete.casillaLocker}
                                        onChange={e => setNuevoPaquete({ ...nuevoPaquete, casillaLocker: e.target.value })}
                                        style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '10px' }}
                                    >
                                        <option value="">-- Sin Locker Asignado --</option>
                                        {lockersDisponibles.map(locker => (
                                            <option key={locker.id} value={locker.identificador}>{locker.identificador}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Foto de Evidencia (Opcional)</label>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <label htmlFor="foto-upload" style={{ cursor: 'pointer', padding: '10px', background: '#f3f4f6', borderRadius: '8px', border: '1px dashed #9ca3af', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                            <IoCameraOutline size={20} /> {fotoEvidencia ? 'Cambiar Foto' : 'Tomar/Subir Foto'}
                                        </label>
                                        <input
                                            id="foto-upload"
                                            type="file"
                                            accept="image/*"
                                            // capture="environment"  // Si quieres forzar cámara en móvil, descomenta esto
                                            onChange={handleFotoChange}
                                            style={{ display: 'none' }}
                                        />
                                        {fotoEvidencia && <span style={{ fontSize: '0.8rem', color: '#10b981' }}>{fotoEvidencia.name}</span>}
                                    </div>
                                </div>

                                <div className="modal-actions">
                                    <button type="button" className="btn-cancelar" onClick={() => setShowRecibirModal(false)} disabled={uploadingFoto}>Cancelar</button>
                                    <button type="submit" className="btn-guardar" disabled={uploadingFoto}>
                                        {uploadingFoto ? 'Registrando...' : 'Registrar Paquete'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {/* Modal para Administrar Lockers */}
                {showAdminLockersModal && (
                    <div className="modal-overlay" onClick={() => setShowAdminLockersModal(false)}>
                        <div className="modal-content" onClick={e => e.stopPropagation()}>
                            <button className="close-modal-btn" onClick={() => setShowAdminLockersModal(false)}>
                                <IoCloseCircleOutline size={24} />
                            </button>
                            <h3>Gestión de Lockers</h3>
                            <p style={{ fontSize: '0.85rem', color: '#6b7280', marginBottom: '15px' }}>
                                Agrega los casilleros físicos disponibles en caseta para que los vigilantes puedan asignar paquetes.
                            </p>

                            <form onSubmit={handleCrearLocker} style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                                <input
                                    type="text"
                                    value={nuevoLockerId}
                                    onChange={e => setNuevoLockerId(e.target.value)}
                                    placeholder="Ej: A-01, B-02"
                                    style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #d1d5db' }}
                                    required
                                />
                                <button type="submit" className="btn-primary" style={{ padding: '10px 15px' }}>
                                    <IoAddCircleOutline size={20} />
                                </button>
                            </form>

                            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                {todosLockers.filter(l => l.estado !== 'eliminado').length === 0 ? (
                                    <p style={{ textAlign: 'center', color: '#9ca3af', padding: '20px 0' }}>No hay lockers registrados.</p>
                                ) : (
                                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                        {todosLockers.filter(l => l.estado !== 'eliminado').map(locker => (
                                            <li key={locker.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', borderBottom: '1px solid #f3f4f6' }}>
                                                <div>
                                                    <strong style={{ display: 'block' }}>{locker.identificador}</strong>
                                                    <span style={{ fontSize: '0.75rem', color: locker.estado === 'libre' ? '#059669' : '#dc2626' }}>
                                                        {locker.estado.toUpperCase()}
                                                    </span>
                                                </div>
                                                {locker.estado === 'libre' && (
                                                    <button onClick={() => handleEliminarLocker(locker.id)} style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', padding: '5px' }}>
                                                        <IoTrashOutline size={18} />
                                                    </button>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal de Confirmación de Entrega Premium */}
                {showConfirmModal && (
                    <div className="modal-overlay confirm-modal-overlay">
                        <div className="modal-content confirm-modal-content premium-popup">
                            <div className="confirm-icon-wrapper">
                                <IoCheckmarkCircleOutline size={46} className="confirm-icon" />
                            </div>
                            <h3>Confirmar Entrega</h3>
                            <p className="confirm-message">
                                ¿Confirmas que el residente ya recogió este paquete de caseta?
                            </p>
                            {paqueteAEntregar?.casillaLocker && paqueteAEntregar?.casillaLocker !== 'N/A' && (
                                <div className="confirm-details">
                                    <span>Locker asignado: <strong>{paqueteAEntregar.casillaLocker}</strong></span>
                                </div>
                            )}
                            <div className="confirm-actions">
                                <button 
                                    type="button" 
                                    className="btn-cancelar" 
                                    onClick={() => { setShowConfirmModal(false); setPaqueteAEntregar(null); }}
                                >
                                    Cancelar
                                </button>
                                <button 
                                    type="button" 
                                    className="btn-confirmar-entrega" 
                                    onClick={ejecutarEntregaPaquete}
                                >
                                    Sí, Entregado
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                    </div>
                </div>
            </main>

            <KondoBottomNav activeRoute="/paqueteria" />
        </div>
    );
}

export default PaqueteriaScreen;
